import {
  DAILY_NAV_COMPANIES_TAB,
  DAILY_NAV_SETTINGS_TAB,
  SCALAR_AI_SETTINGS_TAB,
  SCIM_CONFIGURATION_TAB,
  SINGLE_SIGN_ON_TAB,
} from 'common/constants/firms';
import { USER_MANAGEMENT_TAB } from 'common/constants/user';
import { PRIMARY_NAV_SLUGS } from './PrimaryNavigation/PrimaryNavigation.constants';

export const FIRM_WORKSPACE_ROUTE_PATHS = {
  // /firms/:firmSlugParam
  BASE: '/firms/:firmSlugParam',
  // /firms/:firmSlugParam/home
  HOME: 'home',
  // /firms/:firmSlugParam/intelligence
  INTELLIGENCE: PRIMARY_NAV_SLUGS.INTELLIGENCE,
  // /firms/:firmSlugParam/intelligence/:secondaryTabSlugParam/:tertiaryTabSlugParam?
  // secondary = 'summaries' | 'schedule-of-investments'; tertiary only applies under summaries.
  INTELLIGENCE_TAB: `${PRIMARY_NAV_SLUGS.INTELLIGENCE}/:secondaryTabSlugParam/:tertiaryTabSlugParam?`,
  // /firms/:firmSlugParam/valuations
  VALUATIONS: PRIMARY_NAV_SLUGS.VALUATIONS,
  // /firms/:firmSlugParam/valuations/:tertiaryTabSlugParam/:tertiaryViewSlugParam?
  VALUATIONS_TERTIARY: `${PRIMARY_NAV_SLUGS.VALUATIONS}/:tertiaryTabSlugParam/:tertiaryViewSlugParam?`,
  // /firms/:firmSlugParam/waterfalls
  WATERFALLS: PRIMARY_NAV_SLUGS.WATERFALLS,
  // /firms/:firmSlugParam/documents
  DOCUMENTS: PRIMARY_NAV_SLUGS.DOCUMENTS,
  // /firms/:firmSlugParam/documents/:documentsTabSlugParam
  DOCUMENTS_TAB: `${PRIMARY_NAV_SLUGS.DOCUMENTS}/:documentsTabSlugParam`,
  // /firms/:firmSlugParam/companies/:companySlugParam/:tableSlugParam
  COMPANY_TAB: 'companies/:companySlugParam/:tableSlugParam',
  // /firms/:firmSlugParam/audit-logs
  AUDIT_LOGS: 'audit-logs',
  // /firms/:firmSlugParam/comp-groups
  COMP_GROUPS: 'comp-groups',
  // /firms/:firmSlugParam/sso
  SINGLE_SIGN_ON: SINGLE_SIGN_ON_TAB,
  // /firms/:firmSlugParam/scim
  SCIM_CONFIGURATION: SCIM_CONFIGURATION_TAB,
  // /firms/:firmSlugParam/daily-nav-settings
  DAILY_NAV_SETTINGS: DAILY_NAV_SETTINGS_TAB,
  // /firms/:firmSlugParam/daily-nav-companies
  DAILY_NAV_COMPANIES: DAILY_NAV_COMPANIES_TAB,
  // /firms/:firmSlugParam/scalar-ai
  SCALAR_AI_SETTINGS: SCALAR_AI_SETTINGS_TAB,
  // /firms/:firmSlugParam/user-management
  USER_MANAGEMENT: USER_MANAGEMENT_TAB,
  // /firms/:firmSlugParam/fund-investments/:companySlugParam/:tableSlugParam?
  FUND_INVESTMENT_TAB: 'fund-investments/:companySlugParam/:tableSlugParam?',
  // /firms/:firmSlugParam/users/:tabSlugParam
  USER_TAB: 'users/:tabSlugParam',
  // /firms/:firmSlugParam/users/:userIdParam/account-settings
  USER_DETAIL_ACCOUNT_SETTINGS: 'users/:userIdParam/account-settings',
  // /firms/:firmSlugParam/users/:userIdParam/:tabSlugParam
  USER_DETAIL_TAB: 'users/:userIdParam/:tabSlugParam',
  // /firms/:firmSlugParam/:tableSlugParam
  FIRM_TAB: ':tableSlugParam',
} as const;
